import { DETECTION_SOURCE } from 'src/stores/ml/types';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { pushEvent } from 'src/utils/event-gateway';

export interface AfterMatchPopupEventParam {
  /**
   * after match popup을 트리거 원인
   * https://www.notion.so/hpcnt/WEB-HVS-HVM-32ece00cd35480b8bd19e2545653fb80?source=copy_link#32ece00cd354804a9366f24cd96c3102
   * fakeadult, visual 등
   */
  popupCategory: string;
  screenName: 'MatchFinding' | 'Mirror';
  detection_source: DETECTION_SOURCE;
  match_id: string;
  request_id: string;
  event_counter?: string;
  speech_recognition_api?: string;
}

export const pushAfterMatchPopupShowEvent = (eventParams: AfterMatchPopupEventParam) => {
  pushEvent({
    eventType: EVENT_TYPE.REPORT,
    eventName: EVENT_NAME.MATCHING_AFTER_AUTOPOPUP_SHOW,
    eventParams,
  });
};

export const pushAfterMatchPopupReportEvent = (eventParams: AfterMatchPopupEventParam) => {
  pushEvent({
    eventType: EVENT_TYPE.REPORT,
    eventName: EVENT_NAME.MATCHING_AFTER_AUTOPOPUP_REPORT,
    eventParams,
  });
};

export const pushAfterMatchPopupCancelEvent = (eventParams: AfterMatchPopupEventParam) => {
  pushEvent({
    eventType: EVENT_TYPE.REPORT,
    eventName: EVENT_NAME.MATCHING_AFTER_AUTOPOPUP_CANCEL,
    eventParams,
  });
};
